import React, { useState, useEffect } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import { isValidNumber } from "libphonenumber-js";
import { getDialCode, getCountryCode } from "./CountryCode";
import styled from "styled-components";

function PhoneField({
  countryCodeNumber,
  setCountryCodeNumber,
  phoneWithoutCountryCode,
  setPhoneWithoutCountryCode,
  isPhoneValid,
  setIsPhoneValid,
  initialFullPhone,
}) {
  // Detecta o país do navegador inicialmente
  const [countryCode] = useState(() => {
    const browserCode = (
      navigator.language.split("-")[1] || "US"
    ).toLowerCase();
    return countryCodeNumber ? getCountryCode(countryCodeNumber) : browserCode;
  });

  // Preenche os campos no primeiro carregamento, sem sobrescrever após salvar
  useEffect(() => {
    if (
      initialFullPhone &&
      initialFullPhone.startsWith("+") &&
      phoneWithoutCountryCode === ""
    ) {
      const match = initialFullPhone.match(/^\+?(\d{1,4})(\d{6,})$/);
      if (match) {
        const [, dialCode, localNumber] = match;
        setCountryCodeNumber(dialCode);
        setPhoneWithoutCountryCode(localNumber.slice(0, 15)); // ajuste o limite se quiser
      }
    }
  }, [initialFullPhone]);

  // Atualiza o DDI se o país mudar (ex: ao escolher outra bandeira)
  useEffect(() => {
    const dial = getDialCode(countryCode);
    if (dial) {
      setCountryCodeNumber(dial);
    }
  }, [countryCode]);

  // Validação
  useEffect(() => {
    const fullNumber = `+${countryCodeNumber}${phoneWithoutCountryCode}`;
    const isValid = isValidNumber(fullNumber);
    setIsPhoneValid(isValid);
  }, [countryCodeNumber, phoneWithoutCountryCode]);

  // Tratamento da digitação
  const handleChange = (fullValue, data) => {
    const dialCode = data?.dialCode ?? "";
    const raw = fullValue.replace(/[^0-9]/g, "");

    let currentCountryCode = dialCode;
    let withoutCode = raw;

    if (raw.startsWith(dialCode)) {
      withoutCode = raw.slice(dialCode.length);
    } else if (
      raw.length > 4 &&
      countryCodeNumber &&
      raw.startsWith(countryCodeNumber)
    ) {
      withoutCode = raw.slice(countryCodeNumber.length);
      currentCountryCode = countryCodeNumber;
    }

    const limited = withoutCode.slice(0, 15); // ex: 9 dígitos para Portugal

    setCountryCodeNumber(currentCountryCode);
    setPhoneWithoutCountryCode(limited);
  };

  // Debug para console
  useEffect(() => {}, [
    countryCodeNumber,
    phoneWithoutCountryCode,
    isPhoneValid,
    initialFullPhone,
  ]);

  return (
    <div>
      <StyledPhoneInput
        country={countryCode}
        countryCodeEditable={false}
        value={countryCodeNumber + phoneWithoutCountryCode}
        onChange={handleChange}
        inputProps={{
          name: "phone",
          required: true,
          autoFocus: false,
        }}
        inputStyle={{
          width: "100%",
          height: "42px",
          fontSize: "16px",
          borderRadius: "10px",
        }}
        buttonStyle={{ borderRadius: "10px 0 0 10px" }}
        inputMode="numeric"
        enableSearch={true}
        searchPlaceholder="Pesquisar país"
      />
    </div>
  );
}

export default PhoneField;

const StyledPhoneInput = styled(PhoneInput)`
  .form-control:focus {
    border-color: #ee754c !important;
    box-shadow: 0 0 0 0.2rem rgba(238, 117, 76, 0.25) !important;
  }
  .country-list .search-box {
    margin: 8px;
    padding: 10px 12px 10px 38px; /* espaço pro ícone */
    width: calc(100% - 16px);
    border-radius: 8px;
    border: 1px solid #e6e6e6;
    font-size: 14px;
    outline: none;
    background: #fff
      url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%23999' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'><circle cx='11' cy='11' r='8'/><line x1='21' y1='21' x2='16.65' y2='16.65'/></svg>")
      no-repeat 12px center; /* ícone de lupa */
  }

  .country-list .search-box:focus {
    border-color: #ee754c;
    box-shadow: 0 0 0 2px rgba(238, 117, 76, 0.2);
  }

  .country-list .search-box::placeholder {
    color: #9aa0a6;
  }
`;
